import type { CustomerAuthField, CustomerAuthFieldErrorMap } from './validation'

export const clearFieldErrorsFromMap = (
  current: CustomerAuthFieldErrorMap,
  fields?: CustomerAuthField[],
): CustomerAuthFieldErrorMap => {
  if (!fields?.length) return {}
  const next = { ...current }
  for (const field of fields) {
    delete next[field]
  }
  return next
}

export const markTouchedFields = (
  current: Partial<Record<CustomerAuthField, boolean>>,
  fields: CustomerAuthField[],
) => {
  if (!fields.length) return current
  const next = { ...current }
  for (const field of fields) {
    next[field] = true
  }
  return next
}
